import Controller from '@ember/controller';

import { get, set, action, computed } from '@ember/object';
import { reads } from '@ember/object/computed';

import { task, timeout } from 'ember-concurrency';

import { paesiMondoAlfa3, paesiMondoAlfa2 } from 'beebee-base/lib/list_taxes';

import { inject as iController } from '@ember/controller';
import { inject as iService } from '@ember/service';
import getConfig from 'beebee-base/lib/get-config';
import {
  beebeeAjaxGet,
  beebeeAjaxPost,
  clearAttribute,
  notifyUserError,
} from 'beebee-base/lib/utility';

export default class CheckinController extends Controller {
  @iService notify;
  @iController('application') applicationController;
  @iService intl;
  @iService store;
  @iService session;
  @iService log;

  queryParams = ['saferegister'];
  saferegister = false;

  notFound = false;

  @reads('session.option_field.booking_settings.checkin_general_term') generalTerms;

  @computed('session.option_field.booking_settings.checkin_saferegister', 'saferegister')
  get isSaferegister() {
    return this.saferegister || this.session.option_field?.booking_settings?.checkin_saferegister;
  }

  @computed(
    'generalTerms',
    'termAccepted',
    'applicationController.gdprField.organization_term_options.data.@each.{required,registration,active}'
  )
  get canSave() {
    const { generalTerms, termAccepted } = this;

    if (generalTerms) {
      if (termAccepted) {
        let requiredActive = true;

        const organizationTermOptions =
          this.applicationController?.gdprField?.organization_term_options?.data;

        if (Array.isArray(organizationTermOptions)) {
          organizationTermOptions.forEach(function (d) {
            if (d.required && d.registration && !d.active) {
              requiredActive = false;
            }
          });
        }

        return requiredActive;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  @computed('session.option_field.booking_settings')
  get not_required_field() {
    return this.session.option_field?.booking_settings?.checkin_not_required_field || {};
  }

  checkRequired(showError = true) {
    const contact = this.me;
    const fieldReset = [
      'nameError',
      'ragSocialeError',
      'birthError',
      'luogoError',
      'mobileError',
      'mailError',
      'cfError',
      'codfiscaleError',
      'addressError',
    ];
    const fieldTrim = [
      'ragione_sociale',
      'first_name',
      'last_name',
      'cod_fiscale',
      'luogo_nascita',
      'mail',
      'mobile',
    ];

    if (showError) {
      fieldReset.forEach((field) => {
        set(contact, field, false);
      });
    }

    fieldTrim.forEach((field) => {
      const value = clearAttribute(contact.get(field));
      set(contact, field, value);
    });

    let checkField = true;
    const notRequired = this.not_required_field || {};
    const isFisicaGiuridica = contact.get('fisica_giuridica');
    const address = contact.get('addresses')[0];
    const country = address?.location_address_country;
    const countryCode = address?.location_address_country_code;

    if (isFisicaGiuridica) {
      if (!contact.get('ragione_sociale')) {
        if (showError) set(contact, 'ragSocialeError', true);
        checkField = false;
      }
    } else {
      if (!contact.get('first_name') || !contact.get('last_name')) {
        if (showError) set(contact, 'nameError', true);
        checkField = false;
      }
    }

    if (!contact.get('data_nascita') && !notRequired.data_nascita) {
      if (showError) set(contact, 'birthError', true);
      checkField = false;
    }
    if (!contact.get('luogo_nascita') && !notRequired.luogo_nascita) {
      if (showError) set(contact, 'luogoError', true);
      checkField = false;
    }

    if (!contact.get('mail')) {
      if (showError) set(contact, 'mailError', true);
      checkField = false;
    }
    if (!contact.get('mobile') && !notRequired.mobile) {
      if (showError) set(contact, 'mobileError', true);
      checkField = false;
    }

    if (this.setUsername && !this.tmpUsername) {
      if (showError) set(contact, 'usernameError', true);
      checkField = false;
    }

    if (this.setUsername && !this.tmpUPassword) {
      if (showError) set(contact, 'passwordError', true);
      checkField = false;
    }

    if (
      !(
        address?.location_address_street &&
        address?.location_address_house &&
        address?.location_address_postal_code &&
        address?.location_address_city &&
        address?.location_address_country
      ) &&
      !notRequired.address
    ) {
      if (showError) set(contact, 'addressError', true);
      checkField = false;
    }

    const isItaly = country === 'Italia' || ['IT', 'ITA'].includes(countryCode);
    if (isItaly) {
      // completaStraniero() must never run for Italian contacts: it would
      // overwrite the real postal code / fiscal data with placeholder values.
      if (
        !notRequired.cod_fiscale &&
        (!contact.get('cod_fiscale') || contact.get('codFiscaleValidMsg'))
      ) {
        if (showError) set(contact, 'cfError', true);
        checkField = false;
      }
    } else {
      this.completaStraniero();
    }

    return checkField;
  }

  completaStraniero() {
    const item = this.me;
    const contactAddress = item.addresses[0];
    const countryCode = contactAddress?.location_address_country_code;
    const contactId = item.id || '';

    if (!countryCode) {
      this.notify.warning('Seleziona prima un indirizzo!');
      return;
    }

    const convertCountryCodeToAlpha2 = (countryCode) => {
      const index = paesiMondoAlfa3.indexOf(countryCode);
      if (index === -1) return countryCode.substring(0, 2);
      return paesiMondoAlfa2[index];
    };

    const alpha2Code = convertCountryCodeToAlpha2(countryCode);

    set(contactAddress, 'location_address_postal_code', '00000');
    set(item, 'codice_destinatario', 'XXXXXXX');

    if (item.fisica_giuridica) {
      const rimanentiCF = 14 - contactId.length;
      const contactCF = `${alpha2Code}${'00000000000000'.substring(0, rimanentiCF)}${contactId}`;
      set(item, 'cod_fiscale', contactCF);
    } else {
      set(item, 'cod_fiscale', null);
    }

    const rimanentiPIVA = 11 - contactId.length;
    const pIVA = `${alpha2Code}${'999999999'.substring(0, rimanentiPIVA)}${contactId}`;
    set(item, 'piva', pIVA);
  }

  @(task(function* () {
    try {
      if (this.session.token) {
        let me = yield beebeeAjaxGet(
          `${getConfig(this).APP.urlApi}/contacts/me`,
          this.session.token
        );
        // A failed/empty /contacts/me resolves to undefined; me.data.id then
        // threw (twin of Sentry EMBER-SCUOLE-ECOMMERCE-2XM in e-commerce).
        const meId = me?.data?.id;
        if (!meId) {
          return;
        }

        this.store.pushPayload(me);
        const itemStore = this.store.peekRecord('contact', `${meId}`);

        if (!itemStore) {
          return;
        }

        if (!itemStore.addresses.length) {
          itemStore.addresses.push(
            get(this, 'store').createRecord('address', {
              is_invoice: true,
              location_address_country: 'Italia',
              location_address_country_code: 'IT',
            })
          );
        }

        set(this, 'me', itemStore);
      } else if (!this.isSaferegister) {
        this.createNewMe();
      }
    } catch (e) {
      // 4xx/network on /contacts/me must not surface as an unhandled rejection to Sentry
      this.log.warn('loadDataTask: load failed', e);
    }
  }).drop())
  loadDataTask;

  createNewMe() {
    const me = this.store.createRecord('contact');
    me.addresses.push(
      get(this, 'store').createRecord('address', {
        is_invoice: true,
        location_address_country: 'Italia',
        location_address_country_code: 'IT',
      })
    );
    set(this, 'me', me);
  }

  createDataObj() {
    const hashString = (str) => {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0;
      }
      return Math.abs(hash).toString(16);
    };

    const ragione_sociale = clearAttribute(this.me.get('ragione_sociale')) ?? '';
    const first_name = clearAttribute(this.me.get('first_name')) ?? '';
    const last_name = clearAttribute(this.me.get('last_name')) ?? '';
    const mail = clearAttribute(this.me.get('mail')) ?? '';

    const contact = {
      id: this.me.get('id'),
      gdpr: this.applicationController.get('gdprField.organization_term_options.data'),
      fisica_giuridica: this.me.get('fisica_giuridica'),
      ragione_sociale,
      first_name,
      last_name,
      data_nascita: clearAttribute(this.me.get('data_nascita')),
      luogo_nascita: clearAttribute(this.me.get('luogo_nascita')),
      piva: clearAttribute(this.me.get('piva')),
      cod_fiscale: clearAttribute(this.me.get('cod_fiscale')),
      mail,
      mobile: clearAttribute(this.me.get('mobile')),
      addresses: [],
    };

    if (this.me.get('addresses')[0]?.name) {
      contact.addresses.push(this.createAddressObj());
    }

    return {
      contact,
      custom_fields: [],
      validation: hashString(`${mail}|${first_name}|${last_name}|${ragione_sociale}`),
    };
  }

  createAddressObj() {
    const firstAddress = this.me?.get('addresses')[0];
    if (!firstAddress) return null;

    const clean = (value) => (typeof value === 'string' ? value.replace(/'/g, ' ') : value);

    return {
      id: firstAddress.id,
      attributes: {
        id: firstAddress.id,
        name: clean(firstAddress.name),
        icon: firstAddress.icon,
        view: firstAddress.view,
        place_id: firstAddress.place_id,
        location_position_lat: clean(firstAddress.location_position_lat),
        location_position_lng: clean(firstAddress.location_position_lng),
        location_address_text: clean(firstAddress.location_address_text),
        location_address_house: clean(firstAddress.location_address_house),
        location_address_street: clean(firstAddress.location_address_street),
        location_address_postal_code: clean(firstAddress.location_address_postal_code),
        location_address_city: clean(firstAddress.location_address_city),
        location_address_county: clean(firstAddress.location_address_county),
        location_address_state: clean(firstAddress.location_address_state),
        location_address_country: clean(firstAddress.location_address_country),
        location_address_country_code: clean(firstAddress.location_address_country_code),
        categories_id: firstAddress.categories_id,
        categories_title: clean(firstAddress.categories_title),
        type: firstAddress.type,
        is_invoice: firstAddress.is_invoice,
        accuracy: firstAddress.accuracy,
        heading: firstAddress.heading,
      },
    };
  }

  @(task(function* () {
    yield timeout(250);

    const checkField = this.checkRequired();
    if (checkField) {
      const dataSave = this.createDataObj();
      dataSave.contact.username = this.tmpUsername;
      dataSave.contact.password = this.tmpUPassword;

      try {
        let saveAPIMe = yield beebeeAjaxPost(
          `${getConfig(this).APP.urlApi}/checkin/savecontact`,
          this.session.token,
          dataSave
        );

        const bookingForms = this.session.option_field?.booking_forms;
        const checkinForm = Array.isArray(bookingForms) && bookingForms.find((f) => f.checkin);
        if (checkinForm?.url) {
          const separator = checkinForm.url.includes('?') ? '&' : '?';
          window.location.replace(`${checkinForm.url}${separator}access_token=${saveAPIMe?.token}&from_checkin=1`);
          return;
        }

        const redirectUrl = this.session.option_field?.booking_settings?.redirect_checkin;
        if (redirectUrl) {
          window.location.replace(redirectUrl);
          return;
        }

        set(this, 'saveAPIMe', saveAPIMe);
        return saveAPIMe;
      } catch (e) {
        notifyUserError(this.notify, e, this.intl);
      }
    } else {
      this.notify.warning(this.intl.t('missing mandatory fields'));
    }
  }).drop())
  saveMeTask;

  @(task(function* () {
    try {
      yield beebeeAjaxPost(
        `${getConfig(this).APP.urlApi}/user_registration_request`,
        this.session.token,
        {
          data: {
            attributes: {
              mail: this.me.get('mail'),
              contact_id: this.me.get('id'),
            },
          },
        }
      );
      this.notify.success(`${this.intl.t('message sent to')} ${this.me.get('mail')}`);
    } catch (e) {
      this.notify.error(this.intl.t('beebeeboard error'));
    }
  }).drop())
  sendInvitation;

  @(task(function* () {
    yield timeout(250);

    set(this, 'checkAPIMail', null);
    try {
      let checkAPIMail = yield beebeeAjaxGet(
        `${getConfig(this).APP.urlApi}/checkin/checkmail`,
        null,
        {
          mail: this.checkMail,
          organization_name: this.session.openOrganization?.name,
          thumbnail_url: this.session.openOrganization?.thumbnail_url,
          color: this.session.openOrganization?.primary_color,
          lang: this.intl.primaryLocale,
        }
      );

      set(this, 'checkAPIMail', checkAPIMail);
    } catch (e) {
      // email non trovata — mostra form vuoto
      this.createNewMe();
    }
  }).drop())
  findMailTask;

  @action
  submitFindMail(event) {
    event?.preventDefault?.();
    this.findMailTask.perform();
  }

  @action
  resetForm() {
    set(this, 'me', null);
    set(this, 'checkAPIMail', null);
    set(this, 'saveAPIMe', null);
  }

  @action
  newRegistration() {
    this.createNewMe();
    set(this, 'checkAPIMail', null);
    set(this, 'saveAPIMe', null);
  }
}
